var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9387 1.0401L10.9388 1.04009C11.6807 0.319969 12.8897 0.319969 13.6316 1.04009L13.6316 1.04011C14.3652 1.75212 14.3652 2.90015 13.6316 3.61217L13.6316 3.61218L7.1051 9.94672C7.05595 9.99442 6.98614 10.0238 6.91041 10.0238H4.60694C4.44485 10.0238 4.33912 9.90004 4.33912 9.77855V7.54283C4.33912 7.48267 4.36361 7.42185 4.41221 7.37469L4.41224 7.37466L10.9387 1.0401ZM5.02653 7.49272L4.87476 7.64002V7.85151V9.03331V9.53331H5.37476H6.59238H6.79513L6.94062 9.3921L13.2422 3.27582C13.7808 2.75308 13.7808 1.89919 13.2422 1.37646C12.712 0.861825 11.8583 0.861825 11.3281 1.37645L5.02653 7.49272ZM2.30347 1.82614C1.61745 1.82614 1.03565 2.36968 1.03565 3.07138V12.0143C1.03565 12.716 1.61746 13.2595 2.30347 13.2595H11.5173C12.2034 13.2595 12.7852 12.716 12.7852 12.0143V9.03331C12.7852 8.91182 12.8909 8.78807 13.053 8.78807C13.2151 8.78807 13.3208 8.91182 13.3208 9.03331V12.0143C13.3208 12.959 12.5276 13.75 11.5173 13.75H2.30347C1.29326 13.75 0.5 12.959 0.5 12.0143V3.07138C0.5 2.12673 1.29327 1.33566 2.30347 1.33566H5.37476C5.53686 1.33566 5.64259 1.45941 5.64259 1.5809C5.64259 1.70238 5.53686 1.82614 5.37476 1.82614H2.30347Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateChat);
export default __webpack_public_path__ + "static/media/CreateChat.a73e040432016d7407eb5dbd2c2fa01f.svg";
export { ForwardRef as ReactComponent };